<template>
	<h1>Dashboard CMS</h1>
</template>

<script>

	export default {
		props: ['user', 'isAuth'],
		components: {
		},
		data () {
			return {
			}
		},
		methods: {
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/cms/dashboard/layout/Dashboard.vue